module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list', {
    attrs: {
      "listTitle": "Migração de anúncios",
      "listLogo": _vm.moduleDefinition.logo,
      "filterTitle": "Filtros",
      "loading": _vm.loading,
      "sortFields": _vm.sortFields,
      "sortDefault": {
        field: _vm.sortFields[0],
        order: 'asc'
      },
      "total": _vm.mercadoLivreAnnouncementsMigrationTotal
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": "Conta"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.account),
      expression: "options.account"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "account", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.mercadoLivreAccounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account.identifier
      }
    }, [_vm._v(_vm._s(((account.name) + " (" + (account.nickname) + ")")))])
  })], 2)]), _vm._v(" "), (_vm.options.account) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Código do anúncio"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.code),
      expression: "options.code"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Título do anúncio"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.title),
      expression: "options.title"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Status de Migração"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.status),
      expression: "options.status"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.migration.status), function(status) {
    return _c('option', {
      domProps: {
        "value": status
      }
    }, [_vm._v(_vm._s(_vm.$t(("mercadoLivre.migration." + status + ".label"))))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Status do Anúncio"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.statusAnnouncement),
      expression: "options.statusAnnouncement"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "statusAnnouncement", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.statusesAnnouncement), function(status) {
    return _c('option', {
      domProps: {
        "value": status
      }
    }, [_vm._v(_vm._s(_vm.$t((status + ".label"))))])
  })], 2)])], 1)]) : _vm._e()], 1), _vm._v(" "), (_vm.announcementsMigration.length && _vm.options.account) ? _c('div', {
    staticClass: "l-col-12@md"
  }, _vm._l((_vm.announcementsMigration), function(announcementMigration) {
    return _c('announcement-migration-card', {
      key: _vm.announcementsMigration,
      attrs: {
        "modules": _vm.modules,
        "announcement": announcementMigration,
        "account": _vm.options.account
      }
    })
  }), 1) : _c('div', {
    staticClass: "l-col-12@md u-textCenter"
  }, [_c('panel', [_vm._v("Nenhum anúncio encontrado.")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aa31f2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AnnouncementMigration/Migration.vue
// module id = 3063
// module chunks = 0